import moment from "moment";
import axios from "~/plugins/axios";
import DateFormatEnum from "../enums/DateFormatEnum";

export default {
  getByAppointmentTypeAndStartDate(
    appointmentTypeId,
    startDate,
    endDate = null,
    resourceId = null,
    includes = [],
  ) {
    let startDateMoment;
    if (moment.isMoment(startDate)) {
      startDateMoment = startDate;
    } else if (moment(startDate, moment.ISO_8601, true).isValid()) {
      startDateMoment = moment(startDate, moment.ISO_8601);
    } else {
      throw new Error("Start date is not a moment and does not comply with ISO_8601.");
    }

    let endDateMoment;
    if (moment.isMoment(endDate)) {
      endDateMoment = endDate;
    } else if (moment(endDate, moment.ISO_8601, true).isValid()) {
      endDateMoment = moment(endDate, moment.ISO_8601);
    }

    return axios.post("/web_api/v1/online_afspraken/bookable_time/by_appointment_type_and_start_date", {
      appointment_type_id: appointmentTypeId,
      start_date: startDateMoment.format(DateFormatEnum.DATE),
      end_date: moment.isMoment(endDateMoment) ? endDateMoment.format(DateFormatEnum.DATE) : null,
      resource_id: resourceId,
    }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
};
